import { create } from 'zustand';

type FulfilmentDrawerStore = {
    isOpen: boolean;
    open: () => void;
    close: () => void;
};

export const useFulfilmentDrawerStore = create<FulfilmentDrawerStore>()(set => ({
    isOpen: false,
    open: () => set({ isOpen: true }),
    close: () => set({ isOpen: false }),
}));
